import { z } from "zod";
import { BaseOutputSchema } from "../BaseOutput";

export const ScheduleReportOutputSchema = BaseOutputSchema.extend({
    historyId: z.string(),
});

export type ScheduleReportOutput = z.infer<typeof ScheduleReportOutputSchema>;